import { render, staticRenderFns } from "./FundingProjectsView.vue?vue&type=template&id=1379b1b0&"
import script from "./FundingProjectsView.vue?vue&type=script&lang=js&"
export * from "./FundingProjectsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports